<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mr-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Upcoming Service
        </v-card-title>
        <page-loader :loading="isFetching" />
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.title"
                outlined
                label="Title"
                :error-messages="errors.title"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <input
                type="file"
                id="imagepath"
                name="imagepath"
                ref="imagepath"
                accept="image/*"
                :error-messages="errors.imagepath"
                @change="onFileChange"
              />
              <span v-if="errors.imagepath" class="error--text">{{
                errors.imagepath
              }}</span>
              <v-btn
                v-if="image_url || form.imagepath"
                x-small
                class="reset_image my-1"
                color="red"
                dark
                @click="($refs.imagepath.value = null), (image_url = null)"
                >Remove</v-btn
              >

              <div id="preview" v-if="image_url || form.imagepath" class="mt-5">
                <label for="">Image Preview</label>
                <br />
                <img
                  :src="image_url || mediaUrl + form.imagepath"
                  style="height: 30%; width: 30% !important"
                />
              </div>
            </v-col>
            <v-col sm="12">
              <label for="disclaimer " class="dark-label">Description</label>
              <vue-editor
                ref="disclaimer"
                v-model="form.description"
                class="form-control"
                :error-messages="errors.description"
              />
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn v-can:edit="'upcoming_services'"
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Upcoming Service
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import { VueEditor } from "vue2-editor";
import axios from "axios";

export default {
  name: "UpcomingServiceEditPage",
  components: {
    VueEditor,
  },
  data() {
    return {
      form: {
        is_active: false,
      },
      isLoading: false,
      isFetching: false,
      image_url: "",
    };
  },
  async mounted() {
    this.isFetching = true;
    try {
      await this.getData();
    } finally {
      this.isFetching = false;
    }
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.upcomingServiceId;
      axios
        .get(`/upcoming_services/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        await axios
          .patch(
            `/upcoming_services/${this.$route.params.upcomingServiceId}`,
            this.form
          )
          .then(async () => {
            await this.handleFileUpload();
            await this.saveUserTimestamp(this.old_json, this.form);
            this.$router.push("/upcoming-services");
          })
          .catch((error) => {
            this.isLoading = false;
            if (error.response.status != 422) {
              console.error(error);
              this.isUnAuthorised();
            }
          });
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      console.log("called");
      console.log("uploading");
      let formData = new FormData();
      formData.append("id", this.form.id);
      // imagepath
      if (this.$refs.imagepath?.files[0]) {
        this.imagepath = this.$refs.imagepath.files[0];
        formData.append("imagepath", this.imagepath);
      }
      await axios
        .post("upcoming_services/upload_upcoming_service", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .catch(function (error) {
          console.log(error);
          console.log("FAILURE!!");
        });
    },
    onFileChange() {
      this.file = this.$refs.imagepath?.files[0];
      if (this.file) {
        this.image_url = URL.createObjectURL(this.file);
      }
    },
  },
};
</script>
